module.exports = __webpack_public_path__ + "6822419576d38aa89768e657ecdb3c5a.svg";